module.exports = __webpack_public_path__ + "static/img/videofirst.b367df35.png";